import { Accordion } from "react-bootstrap";
import s from "./style.module.css";
import React from "react";

import { ContractorRatePlanDetails } from "./ContractorRatePlanDetails";

export const ContractorRatePlansView = ({ ratePlans, contractorId, contractorName, contractorTypes, intermediaries, addresses, isRelatedView }) => {
  // if(isLoading) {
  //   return;
  // }

  return <Accordion className={s.group} alwaysOpen>
    {ratePlans?.map((ratePlan, idx) =>
      (<ContractorRatePlanDetails
          key={idx}
          eventKey={idx}
          contractorId={contractorId}
          contractorName={contractorName}
          ratePlan={ratePlan}
          contractorTypes={contractorTypes}
          addresses={addresses}
          intermediaries={intermediaries}
          isRelatedView={isRelatedView}/>
      ))}
  </Accordion>;
};